export default () => {
  const hostConfig = {
    test: ["test.platform.9five.ai", "test.platform.us.9five.cn"],
    uat: ["test.platform.9five.ai", "test.platform.us.9five.cn"],
    prod: ["platform-us.9five.ai"],
  };

  const host = document.domain.toLowerCase();
  let env = "dev";

  Object.keys(hostConfig).some((key) => {
    if (hostConfig[key].includes(host)) {
      env = key;
      return true;
    }
    return false;
  });

  return env;
};
